<template>
  <div class="mt-component-form">
    <div class="flex-col sm:flex-row sm:justify-between flex items-center my-4">
      <h5 class="w-full flex-1 py-3"><i class="dot"></i>{{ title }}</h5>
      <div class="w-full flex-1 flex items-center justify-end gap-4">
        <vs-button v-if="!isPrint" color="secondary" type="border" @click="handleAddRow">{{ $t('항목추가') }}</vs-button>
        <vs-button v-if="!isPrint" color="secondary" @click="handleRemoveRow">{{ $t('선택삭제') }}</vs-button>
      </div>
    </div>
    <div class="overflow-x-auto">
      <table style="min-width: 1556px">
        <thead>
          <tr>
            <th v-if="!isPrint" rowspan="2" width="50px">
              <vs-checkbox @change="handleCheckAll" :value="allChecked"></vs-checkbox>
            </th>
            <th rowspan="2">{{ $t('공종분류') }}</th>
            <th rowspan="2">{{ $t('세부작업') }}<br />단위작업</th>
            <th rowspan="2">{{ $t('위험성분류') }}</th>
            <th rowspan="2">{{ $t('유해·위험 요인') }}</th>
            <th rowspan="2">{{ $t('재해형태') }}</th>
            <th rowspan="2">{{ $t('현재 위험성 감소대책') }}</th>
            <th colspan="3">{{ $t('현재 위험도') }}</th>
            <th rowspan="2">{{ $t('추가 개선 대책 6등급이상건 위험성 감소대책') }}</th>
            <th colspan="3">{{ $t('개선 後 위험관리 및 조치 계획') }}</th>
          </tr>
          <tr>
            <th width="90">{{ $t('빈도') }}<br />(가능성)</th>
            <th width="90">{{ $t('강도') }}<br />(중대성)</th>
            <th width="90">{{ $t('등급') }}</th>

            <th width="100">{{ $t('개선등급') }}</th>
            <th width="100">{{ $t('개선 예정/완료일') }}</th>
            <th width="100">{{ $t('담당') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, rowIndex) in list" :key="`${rowIndex}-${row.id}`">
            <td v-if="!isPrint">
              <vs-checkbox v-model="row.input_check" :readonly="readonly"></vs-checkbox>
            </td>
            <td>
              <p v-if="isPrint">{{ row.input_1 }}</p>
              <ml-input v-else :readonly="readonly" v-model="row.input_1" class="w-full" />
            </td>
            <td>
              <p v-if="isPrint">{{ row.input_2 }}</p>
              <ml-textarea v-else :readonly="readonly" rows="3" v-model="row.input_2" />
            </td>
            <td>
              <p v-if="isPrint">{{ row.input_3 }}</p>
              <check-type-a-selector v-else v-model="row.input_3" :readonly="readonly" class="w-full" />
            </td>
            <td>
              <p v-if="isPrint">{{ row.input_4 }}</p>
              <ml-textarea v-else :readonly="readonly" rows="3" v-model="row.input_4" />
            </td>
            <td>
              <p v-if="isPrint">{{ row.input_5 }}</p>
              <disaster-class-selector v-else v-model="row.input_5" :readonly="readonly" class="w-full" />
            </td>
            <td>
              <p v-if="isPrint">{{ row.input_6 }}</p>
              <ml-textarea v-else :readonly="readonly" rows="3" v-model="row.input_6" />
            </td>

            <!--        등급-->
            <td>
              <p v-if="isPrint" class="print-input">
                {{ row.input_7 }}
              </p>
              <vs-select v-else class="w-full" autocomplete v-model="row.input_7" :disabled="readonly" @change="handleChangeInput(rowIndex, row.input_7, row.input_8, 'input_9')">
                <vs-select-item :key="index" :value="item.value" :text="item.label" v-for="(item, index) in optionsNumber1" />
              </vs-select>
            </td>
            <td>
              <p v-if="isPrint" class="print-input">
                {{ row.input_8 }}
              </p>
              <vs-select v-else class="w-full" autocomplete v-model="row.input_8" :disabled="readonly" @change="handleChangeInput(rowIndex, row.input_7, row.input_8, 'input_9')">
                <vs-select-item :key="index" :value="item.value" :text="item.label" v-for="(item, index) in optionsNumber2" />
              </vs-select>
            </td>
            <td>
              <p v-if="isPrint" class="print-input">
                {{ row.input_9 }}
              </p>
              <ml-input :readonly="true" class="w-full" v-model="row.input_9" v-else :style="{ color: row.input_9_color }" />
            </td>

            <td>
              <p v-if="isPrint">{{ row.input_11 }}</p>
              <ml-textarea v-else :readonly="readonly" rows="3" v-model="row.input_11" />
            </td>
            <td>
              <p v-if="isPrint">{{ row.input_12 }}</p>
              <vs-select v-else class="w-full" autocomplete v-model="row.input_12" :disabled="readonly">
                <vs-select-item value="낮음(L)" text="낮음(L)" />
                <vs-select-item value="보통(ML)" text="보통(ML)" />
                <vs-select-item value="높음(M)" text="높음(M)" />
                <vs-select-item value="매우높음(H)" text="매우높음(H)" />
              </vs-select>
            </td>
            <td>
              <p v-if="isPrint">{{ row.input_13 }} ~ {{ row.input_14 }}</p>
              <div v-else class="">
                <date-selector v-model="row.input_13" class="py-1" />
                <date-selector v-model="row.input_14" class="py-1" />
              </div>
            </td>
            <td>
              <p v-if="isPrint">{{ row.input_15 }}</p>
              <ml-input v-else :readonly="readonly" v-model="row.input_15" class="w-full" />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import DisasterClassSelector from "@/components/selector/DisasterClassSelector";
import CheckTypeASelector from "@/components/selector/CheckTypeASelector";
import DateSelector from "@/components/selector/DateSelector.vue";
export default {
  name: "TableRiskAppraisal595",
  components: {
    DateSelector,
    CheckTypeASelector,
    DisasterClassSelector,
  },
  props: {
    title: {
      type: String,
      default: () => "4M 위험성 평가표",
    },
    isPrint: Boolean,
    readonly: Boolean,
    hideCodeNumber: Boolean,
    value: Array,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        this.list = value;
      },
    },
    list: {
      immediate: false,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  computed: {
    allChecked() {
      let allCheck = true;
      for (const item of this.list) {
        if (!item.input_check) {
          allCheck = false;
          break;
        }
      }
      return allCheck;
    },
  },
  data() {
    return {
      list: [],

      optionsNumber1: [
        { value: 1, label: "1" },
        { value: 2, label: "2" },
        { value: 3, label: "3" },
        { value: 4, label: "4" },
      ],
      optionsNumber2: [
        { value: 1, label: "1" },
        { value: 2, label: "2" },
        { value: 3, label: "3" },
        { value: 4, label: "4" },
      ],
    };
  },
  methods: {
    handleCheckAll(e) {
      const checked = e.target.checked;
      this.list.forEach((e) => {
        e.input_check = checked;
      });
    },

    handleAddRow() {
      this.list.push({
        id: this.list.length,
        input_check: false,
        input_1: "",
        input_2: "",
        input_3: "",
        input_4: "",
        input_5: "",
        input_6: "",
        input_7: "",
        input_8: "",
        input_9: "",
        input_9_color: "#28C76F",
        input_10: "",
        input_11: "",
        input_12: "",
        input_13: "",
        input_14: "",
        input_15: "",
      });
    },
    handleRemoveRow() {
      this.list = this.list.filter((x) => x.input_check === false);
    },
    // update
    updateList() {
      this.$emit("updateList", this.list);
    },
    // 테이블
    checkColor(value) {
      if (value >= 1 && value <= 4) {
        return "#3c3c3c";
      } else if (value >= 5 && value <= 6) {
        return "#c95611";
      } else {
        return "#E42728";
      }
    },

    handleResult(result) {
      if (result >= 1 && result <= 2) return "1~2(L)";
      else if (result >= 3 && result <= 4) return "3~4(ML)";
      else if (result === 6) return "6(M)";
      else if (result >= 8 && result <= 9) return "8~9(H)";
      else if (result >= 12 && result <= 16) return "12~16(HH)";
    },
    handleChangeInput(id, n1, n2, string) {
      // const f = 1
      // const e = 1
      // const d = 1
      // const c = 1
      // const b = 1
      // const a = 1
      const value = n1 * n2;
      const color = `${string}_color`;
      const result = this.handleResult(value);
      this.list.forEach((i, index) => {
        for (const key in i) {
          if (key === string && index === id) {
            this.list[index][key] = result;
            this.list[index][color] = this.checkColor(value);
          }
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
$w-inpu0: 260px;
$w-inpu1: 220px;
$w-inpu2: 140px;
.center-flex {
  display: flex;
  justify-content: center;
  align-items: center;
}

.bg-1 {
  background-color: #f9f9f9;
  border-bottom: $border;
}

.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}

.mt-component-form {
  margin-top: 15px;
}

.text-box {
  line-height: 19px;
  margin-top: 15px;
  border: $border;
}

/* uploaded File */
.form-group {
  border: $border;
  overflow: auto;
  width: 100%;

  &__header {
    height: 80px;
    width: 100%;
    display: flex;

    &-title {
      min-width: $w-inpu2;
      border-left: $border;
      border-bottom: $border;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    &-title.title-checked {
      margin: 0;
      min-width: 40px;
      max-width: 40px;
      border-left: none;
      padding-left: 10px;
    }
  }

  &__content {
    width: 100%;
    display: flex;

    &-row {
      min-width: $w-inpu2;
      border-left: $border;
      border-bottom: $border;
      padding: 7px;
    }

    &-row.row-checked {
      margin: 0;
      min-width: 40px;
      max-width: 40px;
      border-left: none;
      padding-left: 10px;
    }

    &-row.row-w2 {
      min-width: $w-inpu1;
    }
  }
}

.row-w1 {
  min-width: $w-inpu1;
}

.row-w0 {
  min-width: $w-inpu0;
}

.bx {
  border-left: $border;
  border-right: $border;
}

.br {
  border-right: $border;
}

.bl {
  border-left: $border;
}

.bb {
  border-bottom: $border;
}

table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  th,
  td {
    border: 1px solid #000;
    padding: 15px 8px;
    text-align: center;
    border: 1px solid #cdcdcd;
  }

  th {
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    color: #3c3c3c;
    background: #f9f9f9;
  }

  td {
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: #3c3c3c;
    box-sizing: content-box;

    &.link {
      color: #0085ff;
    }

    div {
      min-height: 18px;
    }
  }
}
</style>
